import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import { useLocation, useHistory } from "react-router-dom";
import CustomToastContainer from "../Common/CustomToastContainer";
import { getUserData } from "../../helpers/utils";
const logoimage = `https://hirepros.co.uk` + "/staticlogo.png";
const bgimg = `https://hirepros.co.uk` + "/bgimg.jpg";

const IframeCode = () => {
  const history = useHistory();
  const User = getUserData();
  const domainPath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredJobs, setFilteredJobs] = useState([
    {
      _id: "673d90111f9b0f93a4ff2105",
      title: "AI Prompt Writer",
      industry: "Information Technology",
      description:
        "This job involves generating AI prompts for various applications within the Information Technology industry.",
      location: {
        lat: null,
        long: null,
        type: "On-Site",
        city: "London",
        area: "Greater London",
        pincode: "WC1A",
        address: "123 AI Street, London",
      },
      jobType: ["Full-Time"],
      Key_responsibility: [
        "Develop AI prompts for automated responses using advanced algorithms.",
        "Create scenarios and dialogues to enhance AI learning capabilities.",
        "Collaborate with software developers to integrate AI prompt solutions into existing systems.",
        "Monitor and analyse AI prompt performance",
        "making necessary improvements.",
        "Stay updated with AI technologies and trends to implement cutting-edge prompt generation techniques.",
        "Conduct quality assurance tests on AI prompt outputs.",
        "Troubleshoot and debug AI prompt functionalities.",
        "Ensure data privacy and security measures are implemented in AI prompt systems.",
        "Provide technical support and training to end-users on AI prompt usage.",
        "Contribute to the continuous improvement of AI prompt systems.",
      ],
      categories: [
        "Software Development",
        "Network Administration",
        "Database Management",
        "Cybersecurity",
        "Data Analysis",
        "IT Support",
      ],
      tools: [],
      hoursPerWeek: "hours/week",
      shift: ["Monday to Friday", "Day Shift", "Night Shift", "Overtime"],
      numberOfPositions: 1,
      skills: [
        "Natural Language Processing (NLP)",
        "Machine Learning",
        "Python Programming",
        "Data Analysis",
        "Problem-solving",
        "Technical Writing",
        "AI Algorithms",
        "Cloud Computing",
        "Communication Skills",
        "Critical Thinking",
      ],
      educationLevel: [
        {
          qualification: "Education",
          details: [
            {
              details:
                "A Bachelor’s degree in Computer Science, Artificial Intelligence, or a related field is preferred.",
              level_of_qualification: "Level 6 (Bachelor’s Degree)",
              _id: "673d9128e35405bb4329a856",
            },
            {
              details: "Relevant A-levels or Diploma in IT disciplines.",
              level_of_qualification: "Level 3-4 (A-Level / Diploma)",
              _id: "673d9128e35405bb4329a857",
            },
          ],
          _id: "673d9128e35405bb4329a855",
        },
        {
          qualification: "Experience",
          details: [
            {
              details:
                "Previous experience in AI prompt generation or similar roles within the IT industry.",
              level_of_qualification: "3-5 years of relevant experience",
              _id: "673d9128e35405bb4329a859",
            },
          ],
          _id: "673d9128e35405bb4329a858",
        },
        {
          qualification: "Industry Knowledge",
          details: [
            {
              details:
                "Understanding of AI technologies, machine learning models, and natural language processing.",
              level_of_qualification: "Intermediate to Advanced",
              _id: "673d9128e35405bb4329a85b",
            },
          ],
          _id: "673d9128e35405bb4329a85a",
        },
        {
          qualification: "Analytical Skills",
          details: [
            {
              details:
                "Ability to analyse AI prompt data and derive meaningful insights.",
              level_of_qualification: "Advanced",
              _id: "673d9128e35405bb4329a85d",
            },
          ],
          _id: "673d9128e35405bb4329a85c",
        },
        {
          qualification: "Communication Skills",
          details: [
            {
              details:
                "Excellent verbal and written communication skills for effective collaboration.",
              level_of_qualification: "Advanced",
              _id: "673d9128e35405bb4329a85f",
            },
          ],
          _id: "673d9128e35405bb4329a85e",
        },
        {
          qualification: "Time Management",
          details: [
            {
              details:
                "Efficiently manage time to meet project deadlines and deliverables.",
              level_of_qualification: "Advanced",
              _id: "673d9128e35405bb4329a861",
            },
          ],
          _id: "673d9128e35405bb4329a860",
        },
        {
          qualification: "Problem-solving Skills",
          details: [
            {
              details:
                "Ability to resolve complex issues related to AI prompt generation.",
              level_of_qualification: "Advanced",
              _id: "673d9128e35405bb4329a863",
            },
          ],
          _id: "673d9128e35405bb4329a862",
        },
        {
          qualification: "Creativity",
          details: [
            {
              details: "Innovate and design creative AI prompt solutions.",
              level_of_qualification: "Intermediate to Advanced",
              _id: "673d9128e35405bb4329a865",
            },
          ],
          _id: "673d9128e35405bb4329a864",
        },
        {
          qualification: "Teamwork",
          details: [
            {
              details:
                "Collaborative approach to work with multidisciplinary teams.",
              level_of_qualification: "Intermediate",
              _id: "673d9128e35405bb4329a867",
            },
          ],
          _id: "673d9128e35405bb4329a866",
        },
        {
          qualification: "Adaptability",
          details: [
            {
              details: "Flexible mindset to adapt to evolving AI technologies.",
              level_of_qualification: "High",
              _id: "673d9128e35405bb4329a869",
            },
          ],
          _id: "673d9128e35405bb4329a868",
        },
      ],
      experienceLevel: [],
      employmentEligibility: [],
      applicationDeadline: "2024-12-20T00:00:00.000Z",
      applicationMethod: ["Online Application, Telephone"],
      pay: {
        minimum: "20000.00",
        maximum: "25000.00",
        rate: "NaN",
        rateType: "Monthly",
      },
      supplementalPay: ["Bonus scheme"],
      benefits: [
        "Flexible working hours",
        "Health insurance",
        "Professional development opportunities",
        "Paid time off",
        "Performance bonuses",
      ],
      company: {
        name: "IT Tech",
        logo: "https://example.com/ittech_logo.png",
        description:
          "IT Tech is a leading technology company specialising in AI solutions.",
      },
      tags: ["AI", "Technology", "IT Solutions", "Artificial Intelligence"],
      status: "Publish",
      postedDate: "2024-11-20T00:00:00.000Z",
      __v: 2,
    },
    {
      _id: "673d981818b3992edd7f4e98",
      title: "Beauty Advisor ",
      industry: "Beauty and Wellness",
      description: "aaaaaaaaaaa",
      location: {
        lat: null,
        long: null,
        city: "High Wycombe",
        area: "",
        pincode: "",
        address: "High Wycombe, UK",
      },
      jobType: ["Full-Time"],
      Key_responsibility: [""],
      categories: ["Fresha", "Mindbody", "Square Appointments"],
      tools: [],
      hoursPerWeek: "hours/week",
      shift: ["Monday to Friday", "Day Shift", "Night Shift", "Overtime"],
      numberOfPositions: 5,
      skills: [],
      educationLevel: [],
      experienceLevel: [],
      employmentEligibility: [],
      applicationDeadline: "2025-01-14T00:00:00.000Z",
      applicationMethod: [""],
      pay: {
        minimum: "NaN",
        maximum: "666000.00",
        rate: "NaN",
        rateType: "Annually",
        showPayBy: "",
      },
      supplementalPay: ["Bonus scheme"],
      benefits: ["Referral programme"],
      company: {
        name: "Ai tech",
        logo: "",
        description: "",
      },
      tags: [],
      status: "Publish",
      postedDate: null,
      __v: 1,
    },
    {
      _id: "6746e5b8c12d1fa853392f20",
      title: "Hair Dresser",
      industry: "Information Technology",
      description:
        "As a Hair Dresser within the Information Technology industry, you will be responsible for providing hairdressing services to employees, ensuring a professional and stylish appearance.",
      location: {
        lat: null,
        long: null,
        type: "On-Site",
        city: "London",
        area: "Central London",
        pincode: "WC1B",
        address: "123 Oxford Street, London",
      },
      jobType: ["Full-Time"],
      Key_responsibility:
        "• Offer hairdressing services such as cutting, styling, and treatments to employees.\r\n• Maintain cleanliness and hygiene in the hairdressing area.\r\n• Provide consultations to employees on suitable hairstyles.\r\n• Keep up-to-date with latest hair trends and styles.\r\n• Manage hair appointments and schedules efficiently.\r\n• Ensure the availability of hairdressing products and tools.\r\n• Assist in the organisation of corporate events involving hairstyling.\r\n• Maintain a positive and friendly attitude towards clients.\r\n• Offer advice on haircare tips and products.\r\n• Adhere to safety and health regulations in the workplace.",
      categories: [
        "Software Development",
        "Network Administration",
        "Database Management",
        "Cybersecurity",
        "Data Analysis",
        "IT Support",
      ],
      tools: [],
      hoursPerWeek: "hours/week",
      shift: [
        "Monday to Friday",
        "Day Shift",
        "Night Shift",
        "Overtime",
        "Morning Shift",
        "Afternoon Shift",
      ],
      numberOfPositions: 1,
      skills: [
        "Hair Cutting",
        "Styling Techniques",
        "Customer Service",
        "Product Knowledge",
        "Appointment Management",
      ],
      educationLevel: [
        {
          qualification: "Education",
          details: [
            {
              details:
                "A Bachelor’s degree in Hairdressing or a related field is often preferred.",
              level_of_qualification: "Level 6 (Bachelor’s Degree)",
              _id: "6746e6613189b547efa1118f",
            },
            {
              details: "Relevant Vocational Qualifications in Hairdressing.",
              level_of_qualification: "Level 3-5 (NVQ or Diploma)",
              _id: "6746e6613189b547efa11190",
            },
          ],
          _id: "6746e6613189b547efa1118e",
        },
        {
          qualification: "Experience",
          details: [
            {
              details: "Previous experience as a Hair Stylist or Hair Dresser.",
              level_of_qualification: "3-5 years of relevant experience",
              _id: "6746e6613189b547efa11192",
            },
          ],
          _id: "6746e6613189b547efa11191",
        },
        {
          qualification: "Industry Knowledge",
          details: [
            {
              details:
                "Understanding of hairdressing trends, techniques, and products.",
              level_of_qualification: "Intermediate to Advanced",
              _id: "6746e6613189b547efa11194",
            },
          ],
          _id: "6746e6613189b547efa11193",
        },
        {
          qualification: "Customer Service Skills",
          details: [
            {
              details:
                "Excellent customer interaction and service provision skills.",
              level_of_qualification: "Advanced",
              _id: "6746e6613189b547efa11196",
            },
          ],
          _id: "6746e6613189b547efa11195",
        },
        {
          qualification: "Creativity and Styling Skills",
          details: [
            {
              details: "Ability to create unique and appealing hairstyles.",
              level_of_qualification: "Advanced",
              _id: "6746e6613189b547efa11198",
            },
          ],
          _id: "6746e6613189b547efa11197",
        },
      ],
      experienceLevel: [],
      employmentEligibility: [],
      applicationDeadline: "2024-12-27T00:00:00.000Z",
      applicationMethod: ["Online Application, Walk-in"],
      pay: {
        minimum: "50000.00",
        maximum: "50000.00",
        rate: "NaN",
        rateType: "Annually",
      },
      supplementalPay: ["Bonus scheme"],
      benefits: [
        "Health Insurance",
        "Paid Holidays",
        "Training and Development Opportunities",
        "Employee Discounts on Hair Products",
        "Flexible Working Hours",
      ],
      company: {
        name: "Hirepros",
        logo: "default-image.jpg",
        description:
          "HirePros is a recruitment and workforce solutions company that specializes in helping businesses find the talent they need, particularly in highly technical fields. They offer a range of services, including contingent search, where businesses only pay a fee once the ideal candidate is found, and contract consultant services for temporary or short-term needs. Their approach ensures that clients' intellectual and proprietary assets are protected. HirePros is recognized for its ability to find highly specialized talent in industries such as aerospace, healthcare, finance, and manufacturing",
      },
      tags: [
        "Hair Dresser",
        "Hair Stylist",
        "Hairdressing",
        "Information Technology",
      ],
      status: "Publish",
      postedDate: "2024-11-27T00:00:00.000Z",
      __v: 1,
    },
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [JobsData, setJobsData] = useState({
    totalRecords: 3,
  });
  const toastRef = useRef();
  const [customStyles, setCustomStyles] = useState({
    jobBorderColor: "#003366",
    jobCountColor: "#003366",
    jobBackgroundColor: "#ffffff",
    jobTextColor: "#003366",
    jobHoverBackgroundColor: "#f0f8ff",
    buttonBackgroundColor: "#003366",
    buttonprevBackgroundColor: "#003366",
    buttonnextBackgroundColor: "#ffffff",
    buttonTextColor: "#ffffff",
    paginationbuttonTextColor: "#ffffff",
    buttonprevTextColor: "#ffffff",
    buttonnextTextColor: "#003366",
    paginationbuttonBackgroundColor: "#ffa500",
    buttonHoverBackgroundColor: "#0056b3",
    buttonHoverTextColor: "#ffffff",
    buttonprevHoverBackgroundColor: "#0056b3",
    buttonprevHoverTextColor: "#ffffff",
    buttonnextHoverBackgroundColor: "#0056b3",
    buttonnextHoverTextColor: "#ffffff",
    jobTitleColor: "#003366", // Job title color
    companyNameColor: "#666666", // Company name color
    locationColor: "#777777", // Location color
    salaryColor: "#4b8700", // Salary color
    jobTypeColor: "#003366", // Job type color (Full-Time, Part-Time)
    paginationButtonColor: "#ffffff", // Pagination buttons color
    paginationButtonHoverColor: "#003366",
    companyNameBackgroundColor: "#fff", // Company name background color
    locationBackgroundColor: "#f1f4f7", // Location background color
    salaryBackgroundColor: "#f1f4f7", // Salary background color
    jobTypeBackgroundColor: "#fff8eb",
    jobTitleFontSize: 15, // Job title font size
    companyNameFontSize: 16, // Company name font size
    locationFontSize: 14, // Location font size
    salaryFontSize: 16, // Salary font size
    jobTypeFontSize: 14, // Job type font size
    paginationButtonFontSize: 14,
    jobBorderRadius: 10,
  });

  const location = useLocation(); // Jobs per page
  const searchprm = new URLSearchParams(location.search);
  const token = searchprm.get("authtoken"); // Extract the token from the query params
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const domainpath = "https://api.hirepros.co.uk";

  const fetchUserSettings = async (userId) => {
    try {
      const response = await fetch(
        `${domainPath}/api/employer/get-settings/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response, "response");
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch user settings.");
      }

      const data = await response.json();
      setCustomStyles(data.customStyles); // Set fetched settings in state
      console.log("User settings fetched successfully:", data);
    } catch (error) {
      console.error("Error fetching user settings:", error);
      // alert("An error occurred while fetching user settings: " + error.message);
    }
  };

  useEffect(() => {
    if (User?._id) {
      fetchUserSettings(User?._id); // Fetch settings when component mounts or userId changes
    }
  }, [User?._id]);

  // Default button hover text color
  const [hexInputs, setHexInputs] = useState({
    jobBorderColor: customStyles.jobBorderColor,
    jobBackgroundColor: customStyles.jobBackgroundColor,
    jobCountColor: customStyles.jobCountColor,
    jobTextColor: customStyles.jobTextColor,
    jobHoverBackgroundColor: customStyles.jobHoverBackgroundColor,
    buttonBackgroundColor: customStyles.buttonBackgroundColor,
    buttonprevBackgroundColor: customStyles.buttonprevBackgroundColor,
    buttonnextBackgroundColor: customStyles.buttonnextBackgroundColor,
    paginationbuttonBackgroundColor:
      customStyles.paginationbuttonBackgroundColor,
    buttonTextColor: customStyles.buttonTextColor,
    paginationbuttonTextColor: customStyles.paginationbuttonTextColor,
    buttonprevTextColor: customStyles.buttonprevTextColor,
    buttonnextTextColor: customStyles.buttonnextTextColor,
    buttonHoverBackgroundColor: customStyles.buttonHoverBackgroundColor,
    buttonnextHoverBackgroundColor: customStyles.buttonnextHoverBackgroundColor,
    buttonprevHoverBackgroundColor: customStyles.buttonprevHoverBackgroundColor,
    buttonprevHoverTextColor: customStyles.buttonprevHoverTextColor,
    buttonnextHoverTextColor: customStyles.buttonnextHoverTextColor,
    buttonHoverTextColor: customStyles.buttonHoverTextColor,
    jobTitleColor: customStyles.jobTitleColor,
    companyNameColor: customStyles.companyNameColor,
    locationColor: customStyles.locationColor,
    salaryColor: customStyles.salaryColor,
    jobTypeColor: customStyles.jobTypeColor,
    paginationButtonColor: customStyles.paginationButtonColor,
    paginationButtonHoverColor: customStyles.paginationButtonHoverColor,
    companyNameBackgroundColor: customStyles.companyNameBackgroundColor,
    locationBackgroundColor: customStyles.locationBackgroundColor,
    salaryBackgroundColor: customStyles.salaryBackgroundColor,
    jobTypeBackgroundColor: customStyles.jobTypeBackgroundColor,
  });

  // Update custom styles on change
  const handleStyleChange = (key, value) => {
    setCustomStyles((prev) => ({ ...prev, [key]: value }));
  };
  const handleFontSizeChange = (element, action) => {
    setCustomStyles((prevStyles) => {
      const newSize =
        action === "increase"
          ? prevStyles[element] + 1
          : prevStyles[element] - 1;
      return {
        ...prevStyles,
        [element]: newSize < 10 ? 10 : newSize, // Set a minimum font size of 10px
      };
    });
  };
  const getVisiblePages = () => {
    const visiblePages = [];
    const maxVisibleButtons = 5; // Number of page buttons to show

    if (totalPages <= maxVisibleButtons) {
      // Show all page numbers if total pages is less than or equal to max visible buttons
      for (let i = 1; i <= totalPages; i++) {
        visiblePages.push(i);
      }
    } else {
      // Show limited number of page buttons
      let startPage = Math.max(
        1,
        currentPage - Math.floor(maxVisibleButtons / 2)
      );
      let endPage = startPage + maxVisibleButtons - 1;

      // Adjust if near the beginning
      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - maxVisibleButtons + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        visiblePages.push(i);
      }

      // Add ellipsis for skipped ranges
      if (startPage > 1) {
        visiblePages.unshift("...");
        visiblePages.unshift(1);
      }
      if (endPage < totalPages) {
        visiblePages.push("...");
        visiblePages.push(totalPages);
      }
    }

    return visiblePages;
  };
  const MinusIcon = ({ onClick }) => (
    <svg
      className="w-6 h-6 text-blue-600 hover:text-blue-800 transition-transform transform hover:scale-110 cursor-pointer"
      fill="currentColor"
      viewBox="0 0 16 16"
      onClick={onClick}
      style={{
        color: "#fff",
        background: "red",
        borderRadius: "40px",
      }}
    >
      <path d="M3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
    </svg>
  );

  const PlusIcon = ({ onClick }) => (
    <svg
      className="w-6 h-6 text-blue-600 hover:text-blue-800 transition-transform transform hover:scale-110 cursor-pointer"
      fill="currentColor"
      viewBox="0 0 16 16"
      style={{
        color: "#fff",
        background: "green",
        borderRadius: "40px",
      }}
      onClick={onClick}
    >
      <path d="M8 3a.5.5 0 0 1 .5.5V7h3.5a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V8H3a.5.5 0 0 1 0-1h4.5V3.5A.5.5 0 0 1 8 3z" />
    </svg>
  );
  const visiblePages = getVisiblePages();

  const handlePickerChange = (e, key) => {
    const value = e.target.value;
    setCustomStyles((prev) => ({ ...prev, [key]: value })); // Apply the new color to styles
    setHexInputs((prev) => ({ ...prev, [key]: value })); // Update input value
  };

  // Function to handle text changes
  const handleTextChange = (e, key) => {
    const value = e.target.value;
    setHexInputs((prev) => ({ ...prev, [key]: value })); // Track typed input
  };
  // Function to apply text input as the style color
  const handleTextBlur = (key) => {
    let hexValue = hexInputs[key];

    // Check for shorthand hex code (e.g., #fff -> #ffffff)
    if (hexValue.startsWith("#") && hexValue.length === 4) {
      hexValue = `#${hexValue[1]}${hexValue[1]}${hexValue[2]}${hexValue[2]}${hexValue[3]}${hexValue[3]}`;
    }

    // Validate hex format or color name
    const validHex = /^#[0-9A-Fa-f]{6}$/.test(hexValue);
    const validColorName =
      /^(red|green|blue|yellow|black|white|gray|orange|purple|pink|brown|cyan|magenta|lime)$/i.test(
        hexValue
      );

    if (validHex || validColorName) {
      setCustomStyles((prev) => ({ ...prev, [key]: hexValue })); // Apply valid value
    } else {
      // Revert invalid input to the previous value
      setHexInputs((prev) => ({ ...prev, [key]: customStyles[key] }));
      // alert(
      //   "Invalid hex color code or color name. Please enter a valid value."
      // );
    }
  };

  const handleBorderRadiusChange = (action) => {
    setCustomStyles((prevStyles) => {
      const newRadius =
        action === "increase"
          ? prevStyles.jobBorderRadius + 1
          : prevStyles.jobBorderRadius - 1;
      return {
        ...prevStyles,
        jobBorderRadius: newRadius < 0 ? 0 : newRadius, // Prevent radius from going negative
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = User?._id;

    try {
      const response = await fetch(
        `${domainPath}/api/employer/update-settings/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ customStyles }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update settings");
      }

      const data = await response.json();
      toastRef.current.addToast("Settings updated successfully", "success");
      console.log("Settings updated successfully:", data);
      return data; // Return the updated settings or handle them as needed
    } catch (error) {
      console.error("Error updating settings:", error);
      //alert("An error occurred while updating settings: " + error.message);
    }
  };
  return (
    <div className="">
      {/* Search Bar */}

      {/* Job List */}
      <div className="flex p-4 iframesec">
        <section className="hrp-container hrp-section-2 flex-1">
          <div className="hrp-sub-section">
            <div className="joblist container m-auto ">
              <>
                <div className="joblistheader pt-4">
                  <div className="joblistheader-first">
                    <h1
                      style={{
                        color: customStyles.jobCountColor,
                      }}
                    >
                      {JobsData?.totalRecords} jobs found
                    </h1>
                  </div>
                  <div className="joblistheader-second">
                    <button
                      style={{
                        backgroundColor: customStyles.buttonBackgroundColor,
                        color: customStyles.buttonTextColor,
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor =
                          customStyles.buttonHoverBackgroundColor;
                        e.target.style.color =
                          customStyles.buttonHoverTextColor;
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor =
                          customStyles.buttonBackgroundColor;
                        e.target.style.color = customStyles.buttonTextColor;
                      }}
                      // onClick={handleSearch}
                      className="joblist-btnclear"
                    >
                      Search
                    </button>
                    <button
                      style={{
                        backgroundColor: customStyles.buttonBackgroundColor,
                        color: customStyles.buttonTextColor,
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor =
                          customStyles.buttonHoverBackgroundColor;
                        e.target.style.color =
                          customStyles.buttonHoverTextColor;
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor =
                          customStyles.buttonBackgroundColor;
                        e.target.style.color = customStyles.buttonTextColor;
                      }}
                      className="joblist-btnclear"
                      // onClick={(e) => handleClear(e)}
                    >
                      Clear
                    </button>
                  </div>
                </div>
                <div>
                  <div className="joblistbody space-y-4">
                    {filteredJobs?.map((job, index) => (
                      <div
                        className="joblist-card border rounded-lg p-4 lg:flex md:flex items-center justify-between hover:shadow-lg transition-shadow"
                        key={index}
                        style={{
                          borderColor: customStyles.jobBorderColor,
                          backgroundColor: customStyles.jobBackgroundColor,

                          color: customStyles.jobTextColor,

                          // color: customStyles.jobTextColor,
                          borderRadius: `${customStyles.jobBorderRadius}px`,
                        }}
                      >
                        <div className="joblist-cardimg">
                          <img
                            src={
                              job.company.logo.startsWith("http")
                                ? job.company.logo
                                : job.company.logo.includes("uploads")
                                ? `${domainpath}${job.company.logo}`
                                : `${domainpath}/uploads/${job.company.logo}`
                            }
                            alt={`${job.company.name} Logo`}
                            onClick={() =>
                              history.push(
                                `https://hirepros.co.uk/companies/${job.company.name}`
                              )
                            }
                            className="cursor-pointer"
                            // style={{ width: "120px" }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = logoimage; // Replace with a default logo
                            }}
                          />
                          {!job?.company?.logo && (
                            <svg
                              width="62"
                              height="62"
                              viewBox="0 0 62 62"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M30.9999 31.0001L43.9166 18.0834C43.9166 10.9495 38.1338 5.16675 30.9999 5.16675C23.866 5.16675 18.0833 10.9495 18.0833 18.0834L30.9999 31.0001Z"
                                stroke="#003366"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M31 31.0002L18.0833 43.9168C10.9494 43.9168 5.16663 38.134 5.16663 31.0002C5.16663 23.8663 10.9494 18.0835 18.0833 18.0835L31 31.0002ZM31 31.0002L43.9166 18.0835C51.0505 18.0835 56.8333 23.8663 56.8333 31.0002C56.8333 38.134 51.0505 43.9168 43.9166 43.9168L31 31.0002Z"
                                stroke="#003366"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M30.9999 56.8333C38.1338 56.8333 43.9166 51.0505 43.9166 43.9167L30.9999 31L18.0833 43.9167C18.0833 51.0505 23.866 56.8333 30.9999 56.8333Z"
                                stroke="#003366"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </div>
                        <div className="joblist-carddetail">
                          <div className="flex">
                            <span
                              className="briefjobtype"
                              style={{
                                color: customStyles.jobTypeColor,
                                backgroundColor:
                                  customStyles.jobTypeBackgroundColor,
                                fontSize: `${customStyles.jobTypeFontSize}px`,
                              }}
                            >
                              <FeatherIcon icon="briefcase" />
                              {job?.jobType[0]}
                            </span>
                          </div>{" "}
                          <a
                            href={`https://hirepros.co.uk/jobs/${
                              job?._id
                            }?job=${job?.title.replace(
                              /\s+/g,
                              "-"
                            )}&company=${job?.company?.name.replace(
                              /\s+/g,
                              "-"
                            )}`}
                          >
                            <h1
                              style={{
                                color: customStyles.jobTextColor,
                              }}
                            >
                              {job.title}
                            </h1>
                          </a>
                          <p
                            className="cursor-pointer"
                            // onClick={() =>
                            //   history.push(`/companies/${job.company.name}`)
                            // }
                            style={{
                              color: customStyles.companyNameColor,
                              backgroundColor:
                                customStyles.companyNameBackgroundColor,
                              fontSize: `${customStyles.companyNameFontSize}px`,
                            }}
                          >
                            {job?.company?.name}
                          </p>
                          <div className="joblist-cardinner">
                            <div
                              className="joblist-cardinnerdetail"
                              style={{
                                color: customStyles.jobTitleColor,
                                backgroundColor:
                                  customStyles.jobTitleBackgroundColor,
                                fontSize: `${customStyles.jobTitleFontSize}px`,
                              }}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.9997 15H10.9997C10.7345 15 10.4802 14.8947 10.2926 14.7071C10.1051 14.5196 9.99973 14.2653 9.99973 14V11C9.99973 10.7348 10.1051 10.4805 10.2926 10.2929C10.4802 10.1054 10.7345 10 10.9997 10H13.9997C14.2649 10 14.5193 10.1054 14.7068 10.2929C14.8944 10.4805 14.9997 10.7348 14.9997 11V14C14.9997 14.2653 14.8944 14.5196 14.7068 14.7071C14.5193 14.8947 14.2649 15 13.9997 15ZM10.9997 11V14H13.9997V11H10.9997ZM8.99973 13H5.99973C5.60203 12.9996 5.22073 12.8415 4.93951 12.5603C4.65829 12.279 4.50013 11.8977 4.49973 11.5V9.50004H5.49973V11.5C5.49973 11.6326 5.55241 11.7598 5.64618 11.8536C5.73994 11.9474 5.86712 12 5.99973 12H8.99973V13ZM12.9997 9.00004H11.9997V7.50004C11.9997 7.36743 11.9471 7.24025 11.8533 7.14648C11.7595 7.05272 11.6323 7.00004 11.4997 7.00004H8.99973V6.00004H11.4997C11.8974 6.00043 12.2787 6.1586 12.56 6.43982C12.8412 6.72103 12.9993 7.10233 12.9997 7.50004V9.00004ZM7.49973 9.00004C7.41256 9.00008 7.32689 8.97732 7.25123 8.93404L4.99973 7.64404L2.74823 8.93404C2.66379 8.98239 2.56707 9.00505 2.46993 8.99925C2.3728 8.99344 2.27947 8.95942 2.20139 8.90135C2.1233 8.84328 2.06386 8.76368 2.03035 8.67233C1.99684 8.58097 1.99072 8.48182 2.01273 8.38704L2.54323 6.10104L1.13423 4.59104C1.07265 4.52496 1.03011 4.44343 1.01115 4.35512C0.99218 4.26681 0.997492 4.17501 1.02652 4.08947C1.05554 4.00394 1.1072 3.92786 1.17599 3.86933C1.24478 3.81079 1.32815 3.77199 1.41723 3.75704L3.51723 3.40604L4.55023 1.28104C4.59086 1.19762 4.65391 1.12716 4.7323 1.07753C4.8107 1.0279 4.90136 1.00107 4.99414 1.00003C5.08692 0.998993 5.17816 1.02379 5.25765 1.07165C5.33714 1.11952 5.40174 1.18855 5.44423 1.27104L6.54623 3.40604L8.58473 3.75704C8.6736 3.77235 8.75668 3.81142 8.82516 3.87011C8.89363 3.92879 8.94497 4.0049 8.97372 4.09038C9.00246 4.17586 9.00756 4.26752 8.98846 4.35566C8.96936 4.44379 8.92678 4.52513 8.86523 4.59104L7.45623 6.10104L7.98623 8.38704C8.00323 8.46031 8.00348 8.53647 7.98696 8.60985C7.97044 8.68324 7.93757 8.75195 7.89081 8.81086C7.84405 8.86978 7.7846 8.91739 7.71689 8.95014C7.64918 8.9829 7.57495 8.99995 7.49973 9.00004ZM4.99973 6.50004C4.99973 6.50004 5.17123 6.59004 5.24823 6.63454L6.75323 7.49654L6.36123 5.80804L7.50223 4.58554L5.88573 4.30704L5.01323 2.61604L4.19123 4.30704L2.50073 4.58954L3.63773 5.80804L3.24573 7.49654L4.75073 6.63454C4.82873 6.59004 4.99973 6.50004 4.99973 6.50004Z"
                                  fill="#0085FF"
                                />
                              </svg>
                              <span>{job?.title}</span>
                            </div>{" "}
                            {(job?.location?.address &&
                              job.location.address !== "N/A") ||
                            (job?.location?.city &&
                              job.location.city !== "N/A") ||
                            (job?.location?.area &&
                              job.location.area !== "N/A") ? (
                              <div className="joblist-cardinnerdetail">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M9.00028 15.8914L9.54114 15.282C10.1549 14.5791 10.7069 13.9123 11.198 13.278L11.6034 12.7431C13.2963 10.4623 14.1431 8.65197 14.1431 7.31397C14.1431 4.45797 11.8409 2.14282 9.00028 2.14282C6.15971 2.14282 3.85742 4.45797 3.85742 7.31397C3.85742 8.65197 4.70428 10.4623 6.39714 12.7431L6.80257 13.278C7.50323 14.1757 8.23628 15.0469 9.00028 15.8914Z"
                                    stroke="#FF0000"
                                    strokeWidth="1.14286"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M9.00028 9.42854C10.1837 9.42854 11.1431 8.46915 11.1431 7.28568C11.1431 6.10221 10.1837 5.14282 9.00028 5.14282C7.81681 5.14282 6.85742 6.10221 6.85742 7.28568C6.85742 8.46915 7.81681 9.42854 9.00028 9.42854Z"
                                    stroke="#FF0000"
                                    strokeWidth="1.14286"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>

                                <span
                                  style={{
                                    color: customStyles.locationColor,
                                    backgroundColor:
                                      customStyles.locationBackgroundColor,
                                    fontSize: `${customStyles.locationFontSize}px`,
                                  }}
                                >
                                  {job?.location?.address &&
                                  job.location.address !== "N/A"
                                    ? job.location.address
                                    : `${
                                        job.location.city !== "N/A"
                                          ? job.location.city
                                          : ""
                                      } ${
                                        job.location.area !== "N/A"
                                          ? job.location.area
                                          : ""
                                      }`.trim()}
                                </span>
                              </div>
                            ) : null}
                            {job?.pay?.rateType && (
                              <div className="joblist-cardinnerdetail">
                                {job?.pay.rateType !== "" &&
                                job?.pay.rateType !== null &&
                                job?.pay.minimum !== "Not specified" &&
                                job?.pay.minimum !== "NaN" &&
                                job?.pay.maximum !== "NaN" ? (
                                  <>
                                    <div
                                      className="salery-inner"
                                      style={{
                                        color: customStyles.salaryColor,
                                        backgroundColor:
                                          customStyles.salaryBackgroundColor,
                                        fontSize: `${customStyles.salaryFontSize}px`,
                                      }}
                                    >
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M13.9493 7.83333H12.1533C11.204 7.83333 10.4993 8.53933 10.4993 9.33333C10.4993 10.1273 11.204 10.8333 12.1527 10.8333H13.9647C14.102 10.8247 14.1613 10.732 14.166 10.676V7.99066C14.1613 7.93466 14.102 7.842 13.9647 7.834L13.9493 7.83333ZM13.9 6.83333C13.944 6.83333 13.9867 6.83333 14.0267 6.83599C14.6067 6.87133 15.1207 7.30933 15.164 7.92133C15.1667 7.96133 15.1667 8.00466 15.1667 8.04466V10.622C15.1667 10.662 15.1667 10.7053 15.164 10.7453C15.1207 11.3573 14.6067 11.7953 14.026 11.8313C13.9867 11.8333 13.944 11.8333 13.8993 11.8333H12.154C10.724 11.8333 9.5 10.748 9.5 9.33333C9.5 7.91866 10.724 6.83333 12.1533 6.83333H13.8887H13.9Z"
                                          fill="#4B8700"
                                        />
                                        <path
                                          d="M12.6663 9.33334C12.6663 9.51015 12.5961 9.67972 12.4711 9.80474C12.3461 9.92977 12.1765 10 11.9997 10C11.8229 10 11.6533 9.92977 11.5283 9.80474C11.4032 9.67972 11.333 9.51015 11.333 9.33334C11.333 9.15653 11.4032 8.98696 11.5283 8.86193C11.6533 8.73691 11.8229 8.66667 11.9997 8.66667C12.1765 8.66667 12.3461 8.73691 12.4711 8.86193C12.5961 8.98696 12.6663 9.15653 12.6663 9.33334Z"
                                          fill="#4B8700"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M13.8997 6.83334C14.0909 6.82611 14.2813 6.86259 14.4563 6.94C14.385 5.86934 14.1883 5.044 13.5723 4.42734C13.073 3.92867 12.4403 3.70734 11.659 3.602L11.631 3.59867C11.624 3.59338 11.6169 3.58827 11.6097 3.58334L9.11901 1.932C8.68698 1.65005 8.18223 1.49992 7.66634 1.49992C7.15045 1.49992 6.64571 1.65005 6.21367 1.932L3.72367 3.58334C3.71621 3.58826 3.70887 3.59337 3.70167 3.59867L3.67367 3.602C2.89234 3.70734 2.25967 3.92867 1.76034 4.42734C1.26167 4.92667 1.04034 5.55934 0.935008 6.34067C0.833008 7.10067 0.833008 8.07067 0.833008 9.296V9.37067C0.833008 10.596 0.833008 11.5667 0.935008 12.326C1.04034 13.1073 1.26167 13.74 1.76034 14.2393C2.25967 14.738 2.89234 14.9593 3.67367 15.0647C4.43367 15.1667 5.40367 15.1667 6.62901 15.1667H8.70367C9.92901 15.1667 10.8997 15.1667 11.659 15.0647C12.4403 14.9593 13.073 14.738 13.5723 14.2393C14.1883 13.6227 14.385 12.7973 14.4563 11.726C14.3217 11.786 14.1763 11.822 14.0257 11.8313C13.9863 11.8333 13.9437 11.8333 13.899 11.8333H13.445C13.369 12.728 13.1977 13.2 12.865 13.532C12.583 13.814 12.1963 13.9833 11.5257 14.0733C10.841 14.1653 9.93767 14.1667 8.66634 14.1667H6.66634C5.39501 14.1667 4.49234 14.1653 3.80634 14.0733C3.13634 13.9833 2.74967 13.814 2.46767 13.532C2.18567 13.25 2.01634 12.8633 1.92634 12.1927C1.83434 11.508 1.83301 10.6047 1.83301 9.33334C1.83301 8.062 1.83434 7.15934 1.92634 6.47334C2.01634 5.80334 2.18567 5.41667 2.46767 5.13467C2.74967 4.85267 3.13634 4.68334 3.80701 4.59334C4.49234 4.50134 5.39501 4.5 6.66634 4.5H8.66634C9.93767 4.5 10.841 4.50134 11.5263 4.59334C12.1963 4.68334 12.583 4.85267 12.865 5.13467C13.1977 5.46667 13.369 5.93934 13.445 6.83334H13.8883H13.8997ZM6.62901 3.5H8.70367C9.04834 3.5 9.37234 3.5 9.67701 3.502L8.56634 2.76534C8.03301 2.412 7.29967 2.412 6.76634 2.76534L5.65501 3.502C5.96034 3.5 6.28434 3.5 6.62834 3.5"
                                          fill="#4B8700"
                                        />
                                        <path
                                          d="M4 6.16667C3.86739 6.16667 3.74021 6.21935 3.64645 6.31312C3.55268 6.40689 3.5 6.53406 3.5 6.66667C3.5 6.79928 3.55268 6.92646 3.64645 7.02022C3.74021 7.11399 3.86739 7.16667 4 7.16667H6.66667C6.79927 7.16667 6.92645 7.11399 7.02022 7.02022C7.11399 6.92646 7.16667 6.79928 7.16667 6.66667C7.16667 6.53406 7.11399 6.40689 7.02022 6.31312C6.92645 6.21935 6.79927 6.16667 6.66667 6.16667H4Z"
                                          fill="#4B8700"
                                        />
                                        <path
                                          d="M12.6663 9.33334C12.6663 9.51015 12.5961 9.67972 12.4711 9.80474C12.3461 9.92977 12.1765 10 11.9997 10C11.8229 10 11.6533 9.92977 11.5283 9.80474C11.4032 9.67972 11.333 9.51015 11.333 9.33334C11.333 9.15653 11.4032 8.98696 11.5283 8.86193C11.6533 8.73691 11.8229 8.66667 11.9997 8.66667C12.1765 8.66667 12.3461 8.73691 12.4711 8.86193C12.5961 8.98696 12.6663 9.15653 12.6663 9.33334Z"
                                          fill="#4B8700"
                                        />
                                      </svg>

                                      <span>
                                        {job?.pay.rateType === "Range" && (
                                          <>
                                            &#163;{job?.pay.minimum} - &#163;
                                            {job?.pay.maximum}
                                          </>
                                        )}
                                        {job?.pay.rateType === "Fixed" && (
                                          <> &#163;{job?.pay.maximum} (Fixed)</>
                                        )}

                                        {job?.pay.rateType === "Hourly" && (
                                          <>
                                            {" "}
                                            &#163;
                                            {!job?.pay.maximum
                                              ? job?.pay.minimum
                                              : job?.pay.maximum}{" "}
                                            per hour
                                          </>
                                        )}
                                        {job?.pay.rateType ===
                                          "Hourly Rate" && (
                                          <>
                                            {" "}
                                            &#163;{job?.pay.maximum} per hour
                                          </>
                                        )}
                                        {job?.pay.rateType === "Annually" && (
                                          <>
                                            {" "}
                                            &#163;{job?.pay.maximum} per year
                                          </>
                                        )}
                                        {job?.pay.rateType === "Yearly" && (
                                          <>
                                            {" "}
                                            &#163;{job?.pay.maximum} per year
                                          </>
                                        )}
                                        {job?.pay.rateType === "Monthly" && (
                                          <>
                                            {" "}
                                            &#163;{job?.pay.maximum} per month
                                          </>
                                        )}
                                        {job?.pay.rateType === "Weekly" && (
                                          <>
                                            {" "}
                                            &#163;{job?.pay.maximum} per week
                                          </>
                                        )}
                                        {job?.pay.rateType === "Per Day" && (
                                          <> &#163;{job?.pay.maximum} per day</>
                                        )}
                                        {job?.pay.rateType ===
                                          "Per Project" && (
                                          <>
                                            {" "}
                                            &#163;{job?.pay.maximum} per project
                                          </>
                                        )}
                                      </span>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="pagination-controls">
                    <button
                      style={{
                        backgroundColor: customStyles.buttonprevBackgroundColor,
                        color: customStyles.buttonprevTextColor,
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor =
                          customStyles.buttonprevHoverBackgroundColor;
                        e.target.style.color =
                          customStyles.buttonprevHoverTextColor;
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor =
                          customStyles.buttonprevBackgroundColor;
                        e.target.style.color = customStyles.buttonprevTextColor;
                      }}
                      // onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="pagination-button"
                    >
                      Previous
                    </button>
                    {visiblePages.map((page, index) => (
                      <button
                        style={{
                          backgroundColor:
                            customStyles.paginationbuttonBackgroundColor,
                          color: customStyles.paginationbuttonTextColor,
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonHoverBackgroundColor;
                          e.target.style.color =
                            customStyles.buttonprevHoverTextColor;
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor =
                            customStyles.buttonprevBackgroundColor;
                          e.target.style.color =
                            customStyles.buttonprevTextColor;
                        }}
                        key={index}
                        // onClick={() =>
                        //   page !== "..." && handlePageChange(page)
                        // }
                        className={`pagination-button ${
                          currentPage === page ? "active" : ""
                        }`}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      style={{
                        backgroundColor: customStyles.buttonnextBackgroundColor,
                        color: customStyles.buttonnextTextColor,
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor =
                          customStyles.buttonnextHoverBackgroundColor;
                        e.target.style.color =
                          customStyles.buttonnextHoverTextColor;
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor =
                          customStyles.buttonnextBackgroundColor;
                        e.target.style.color = customStyles.buttonnextTextColor;
                      }}
                      // onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className="pagination-button"
                    >
                      Next
                    </button>
                  </div>{" "}
                </div>
              </>
            </div>
          </div>
        </section>

        <aside className="sidebarrr bg-gray-100 p-4 rounded-lg shadow-md w-80 custom-scrollbar">
          <form onSubmit={handleSubmit}>
            {" "}
            <h2 className="text-lg font-bold mb-4">CSS Settings</h2>
            {/* Job Card Styles */}
            <div className="mb-6  border rounded p-3 shadow bg-white">
              <label className="w-1/2 block font-medium text-black text-xs">
                Job count color
              </label>
              <div className="w-full flex items-center gap-2">
                <input
                  type="color"
                  value={customStyles.jobCountColor}
                  onChange={(e) => handlePickerChange(e, "jobCountColor")}
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobCountColor}
                  onChange={(e) => handleTextChange(e, "jobCountColor")}
                  onBlur={() => handleTextBlur("jobCountColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            <div className="mb-6  border rounded p-3 shadow bg-white">
              <label className="w-1/2 block font-medium text-black text-xs">
                Job Border Color
              </label>
              <div className="w-full flex items-center gap-2">
                <input
                  type="color"
                  value={customStyles.jobBorderColor}
                  onChange={(e) => handlePickerChange(e, "jobBorderColor")}
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobBorderColor}
                  onChange={(e) => handleTextChange(e, "jobBorderColor")}
                  onBlur={() => handleTextBlur("jobBorderColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            {/* Job Background Color */}
            <div className="mb-6  border rounded p-3 shadow bg-white">
              <label className="w-full block font-medium text-black text-xs">
                Job Background Color
              </label>
              <div className="w-full flex justify-end gap-2">
                <input
                  type="color"
                  value={customStyles.jobBackgroundColor}
                  onChange={(e) => handlePickerChange(e, "jobBackgroundColor")}
                  className="h-10  w-1/2  cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobBackgroundColor}
                  onChange={(e) => handleTextChange(e, "jobBackgroundColor")}
                  onBlur={() => handleTextBlur("jobBackgroundColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            {/* Job Text Color */}
            <div className="mb-6  border rounded p-3 shadow bg-white ">
              <label className="w-1/2 block font-medium text-black text-xs">
                Job Text Color
              </label>
              <div className="w-full flex items-center gap-2">
                <input
                  type="color"
                  value={customStyles.jobTextColor}
                  onChange={(e) => handlePickerChange(e, "jobTextColor")}
                  className="h-10  w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobTextColor}
                  onChange={(e) => handleTextChange(e, "jobTextColor")}
                  onBlur={() => handleTextBlur("jobTextColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            {/* Job Hover Background Color */}
            <div className="mb-6  border rounded p-3 shadow bg-white">
              <label className="w-full block font-medium text-black text-xs">
                Job Hover Background Color
              </label>
              <div className="w-full flex items-center justify-center gap-2">
                <input
                  type="color"
                  value={customStyles.jobHoverBackgroundColor}
                  onChange={(e) =>
                    handlePickerChange(e, "jobHoverBackgroundColor")
                  }
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobHoverBackgroundColor}
                  onChange={(e) =>
                    handleTextChange(e, "jobHoverBackgroundColor")
                  }
                  onBlur={() => handleTextBlur("jobHoverBackgroundColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            <div className="mb-6 border rounded p-3 shadow bg-white">
              <label className="w-1/2 block font-medium text-black text-xs">
                Job Title Color
              </label>
              <div className="w-full flex items-center gap-2">
                <input
                  type="color"
                  value={customStyles.jobTitleColor}
                  onChange={(e) => handlePickerChange(e, "jobTitleColor")}
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobTitleColor}
                  onChange={(e) => handleTextChange(e, "jobTitleColor")}
                  onBlur={() => handleTextBlur("jobTitleColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            {/* Other Color Inputs */}
            <div className="mb-6 border rounded p-3 shadow bg-white">
              <label className="w-1/2 block font-medium text-black text-xs">
                Company Name Color
              </label>
              <div className="w-full flex items-center gap-2">
                <input
                  type="color"
                  value={customStyles.companyNameColor}
                  onChange={(e) => handlePickerChange(e, "companyNameColor")}
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.companyNameColor}
                  onChange={(e) => handleTextChange(e, "companyNameColor")}
                  onBlur={() => handleTextBlur("companyNameColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            {/* Repeat for other color options */}
            {/* Example for Location Color */}
            <div className="mb-6 border rounded p-3 shadow bg-white">
              <label className="w-1/2 block font-medium text-black text-xs">
                Location Color
              </label>
              <div className="w-full flex items-center gap-2">
                <input
                  type="color"
                  value={customStyles.locationColor}
                  onChange={(e) => handlePickerChange(e, "locationColor")}
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.locationColor}
                  onChange={(e) => handleTextChange(e, "locationColor")}
                  onBlur={() => handleTextBlur("locationColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            {/* Repeat for other color and background color states */}
            {/* Example for Job Background Color */}
            <div className="mb-6 border rounded p-3 shadow bg-white">
              <label className="w-full block font-medium text-black text-xs">
                Job Title Background Color
              </label>
              <div className="w-full flex justify-end gap-2">
                <input
                  type="color"
                  value={customStyles.jobTitleBackgroundColor}
                  onChange={(e) =>
                    handlePickerChange(e, "jobTitleBackgroundColor")
                  }
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobTitleBackgroundColor}
                  onChange={(e) =>
                    handleTextChange(e, "jobTitleBackgroundColor")
                  }
                  onBlur={() => handleTextBlur("jobTitleBackgroundColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            {/* Repeat for all other background color states */}
            {/* Example for Salary Background Color */}
            <div className="mb-6 border rounded p-3 shadow bg-white">
              <label className="w-full block font-medium text-black text-xs">
                Salary Color
              </label>
              <div className="w-full flex justify-end gap-2">
                <input
                  type="color"
                  value={customStyles.salaryBackgroundColor}
                  onChange={(e) =>
                    handlePickerChange(e, "salaryBackgroundColor")
                  }
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.salaryBackgroundColor}
                  onChange={(e) => handleTextChange(e, "salaryBackgroundColor")}
                  onBlur={() => handleTextBlur("salaryBackgroundColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            <div className="mb-6 border rounded p-3 shadow bg-white">
              <label className="w-full block font-medium text-black text-xs">
                Salary Background Color
              </label>
              <div className="w-full flex justify-end gap-2">
                <input
                  type="color"
                  value={customStyles.salaryBackgroundColor}
                  onChange={(e) =>
                    handlePickerChange(e, "salaryBackgroundColor")
                  }
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.salaryBackgroundColor}
                  onChange={(e) => handleTextChange(e, "salaryBackgroundColor")}
                  onBlur={() => handleTextBlur("salaryBackgroundColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            <div className="mb-6 border rounded p-3 shadow bg-white">
              <label className="w-1/2 block font-medium text-black text-xs">
                Job Type Color
              </label>
              <div className="w-full flex items-center gap-2">
                <input
                  type="color"
                  value={customStyles.jobTypeColor}
                  onChange={(e) => handlePickerChange(e, "jobTypeColor")}
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobTypeColor}
                  onChange={(e) => handleTextChange(e, "jobTypeColor")}
                  onBlur={() => handleTextBlur("jobTypeColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            <div className="mb-6 border rounded p-3 shadow bg-white">
              <label className="w-1/2 block font-medium text-black text-xs">
                Job Type Background Color
              </label>
              <div className="w-full flex items-center gap-2">
                <input
                  type="color"
                  value={customStyles.jobTypeBackgroundColor}
                  onChange={(e) =>
                    handlePickerChange(e, "jobTypeBackgroundColor")
                  }
                  className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  value={hexInputs.jobTypeBackgroundColor}
                  onChange={(e) =>
                    handleTextChange(e, "jobTypeBackgroundColor")
                  }
                  onBlur={() => handleTextBlur("jobTypeBackgroundColor")}
                  className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                  placeholder="Enter hex or color name"
                />
              </div>
            </div>
            <div className="mb-6">
              <h3 className="font-semibold mb-4">Font Size Controls</h3>

              <div className="border rounded p-3 shadow bg-white ">
                {/* <h3 className="text-lg font-semibold mb-4">Font Size Controls</h3> */}
                <div className="space-y-5">
                  {[
                    {
                      label: "Job Title Font Size",
                      stateKey: "jobTitleFontSize",
                    },
                    {
                      label: "Company Name Font Size",
                      stateKey: "companyNameFontSize",
                    },
                    {
                      label: "Location Font Size",
                      stateKey: "locationFontSize",
                    },
                    { label: "Salary Font Size", stateKey: "salaryFontSize" },
                    {
                      label: "Job Type Font Size",
                      stateKey: "jobTypeFontSize",
                    },
                    {
                      label: "Pagination Button Font Size",
                      stateKey: "paginationButtonFontSize",
                    },
                  ].map(({ label, stateKey }) => (
                    <div key={stateKey} className="flex items-center space-x-2">
                      <label className="text-sm text-gray-700 flex-1">
                        {label}: {customStyles[stateKey]}px
                      </label>
                      <div className="flex space-x-2">
                        <MinusIcon
                          onClick={() =>
                            handleFontSizeChange(stateKey, "decrease")
                          }
                        />
                        <PlusIcon
                          onClick={() =>
                            handleFontSizeChange(stateKey, "increase")
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>{" "}
            <div className="mb-6">
              <h3 className="font-semibold mb-4">Job Border Radius</h3>

              <div className=" mb-6  border rounded p-3 shadow bg-white">
                {" "}
                <div className="flex items-center space-x-2">
                  <label className="text-sm text-gray-700">
                    Border Radius: {customStyles.jobBorderRadius}px
                  </label>
                  <div className="flex space-x-2">
                    <MinusIcon
                      onClick={() => handleBorderRadiusChange("decrease")}
                    />
                    <PlusIcon
                      onClick={() => handleBorderRadiusChange("increase")}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Button Styles */}
            <div className="mb-6">
              <h3 className="font-semibold mb-4">Button Styles</h3>

              {/* Button Background Color */}
              <div className="mb-6  border rounded p-3 shadow bg-white">
                <label className="w-full block font-medium text-black text-xs">
                  Previous Button Background Color
                </label>
                <div className="w-full flex items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.buttonBackgroundColor}
                    onChange={(e) =>
                      handlePickerChange(e, "buttonBackgroundColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.buttonBackgroundColor}
                    onChange={(e) =>
                      handleTextChange(e, "buttonBackgroundColor")
                    }
                    onBlur={() => handleTextBlur("buttonBackgroundColor")}
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>
              <div className="mb-6  border rounded p-3 shadow bg-white">
                <label className="w-full block font-medium text-black text-xs">
                  Next Button Background Color
                </label>
                <div className="w-full flex items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.buttonBackgroundColor}
                    onChange={(e) =>
                      handlePickerChange(e, "buttonBackgroundColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.buttonBackgroundColor}
                    onChange={(e) =>
                      handleTextChange(e, "buttonBackgroundColor")
                    }
                    onBlur={() => handleTextBlur("buttonBackgroundColor")}
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>

              <div className="mb-6  border rounded p-3 shadow bg-white">
                <label className="w-full block font-medium text-black text-xs">
                  Button Background Search And Clear Color
                </label>
                <div className="w-full flex items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.buttonBackgroundColor}
                    onChange={(e) =>
                      handlePickerChange(e, "buttonBackgroundColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.buttonBackgroundColor}
                    onChange={(e) =>
                      handleTextChange(e, "buttonBackgroundColor")
                    }
                    onBlur={() => handleTextBlur("buttonBackgroundColor")}
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>

              {/* Button Text Color */}

              <div className="mb-6  border rounded p-3 shadow bg-white">
                <label className="w-full block font-medium text-black text-xs">
                  Button Text Color
                </label>
                <div className="w-full flex items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.buttonTextColor}
                    onChange={(e) => handlePickerChange(e, "buttonTextColor")}
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.buttonTextColor}
                    onChange={(e) => handleTextChange(e, "buttonTextColor")}
                    onBlur={() => handleTextBlur("buttonTextColor")}
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>

              {/* Button Hover Background Color */}
              <div className="mb-6  border rounded p-3 shadow bg-white ">
                <label className="w-full block font-medium text-black text-xs">
                  Button Hover Background Color
                </label>
                <div className="w-full flex justify-center items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.buttonHoverBackgroundColor}
                    onChange={(e) =>
                      handlePickerChange(e, "buttonHoverBackgroundColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.buttonHoverBackgroundColor}
                    onChange={(e) =>
                      handleTextChange(e, "buttonHoverBackgroundColor")
                    }
                    onBlur={() => handleTextBlur("buttonHoverBackgroundColor")}
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>

              {/* Button Hover Text Color */}
              <div className="mb-6  border rounded p-3 shadow bg-white ">
                <label className="w-full block font-medium text-black text-xs">
                  Button Hover Text Color
                </label>
                <div className="w-full  flex items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.buttonHoverTextColor}
                    onChange={(e) =>
                      handlePickerChange(e, "buttonHoverTextColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.buttonHoverTextColor}
                    onChange={(e) =>
                      handleTextChange(e, "buttonHoverTextColor")
                    }
                    onBlur={() => handleTextBlur("buttonHoverTextColor")}
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>
              <div className="mb-6  border rounded p-3 shadow bg-white">
                <label className="w-full block font-medium text-black text-xs">
                  Pagination Button Text Color
                </label>
                <div className="w-full flex items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.paginationbuttonTextColor}
                    onChange={(e) =>
                      handlePickerChange(e, "paginationbuttonTextColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.paginationbuttonTextColor}
                    onChange={(e) =>
                      handleTextChange(e, "paginationbuttonTextColor")
                    }
                    onBlur={() => handleTextBlur("paginationbuttonTextColor")}
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>
              <div className="mb-6  border rounded p-3 shadow bg-white">
                <label className="w-full block font-medium text-black text-xs">
                  Pagination Button Background Color
                </label>
                <div className="w-full flex items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.paginationbuttonBackgroundColor}
                    onChange={(e) =>
                      handlePickerChange(e, "paginationbuttonBackgroundColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.paginationbuttonBackgroundColor}
                    onChange={(e) =>
                      handleTextChange(e, "paginationbuttonBackgroundColor")
                    }
                    onBlur={() =>
                      handleTextBlur("paginationbuttonBackgroundColor")
                    }
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>
              <div className="mb-6  border rounded p-3 shadow bg-white ">
                <label className="w-full block font-medium text-black text-xs">
                  Previous Hover Background Color
                </label>
                <div className="w-full flex justify-center items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.buttonprevHoverBackgroundColor}
                    onChange={(e) =>
                      handlePickerChange(e, "buttonprevHoverBackgroundColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.buttonprevHoverBackgroundColor}
                    onChange={(e) =>
                      handleTextChange(e, "buttonprevHoverBackgroundColor")
                    }
                    onBlur={() =>
                      handleTextBlur("buttonprevHoverBackgroundColor")
                    }
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>

              {/* Button Hover Text Color */}
              <div className="mb-6  border rounded p-3 shadow bg-white ">
                <label className="w-full block font-medium text-black text-xs">
                  Next Button Hover Text Color
                </label>
                <div className="w-full  flex items-center gap-2">
                  <input
                    type="color"
                    value={customStyles.buttonnextHoverTextColor}
                    onChange={(e) =>
                      handlePickerChange(e, "buttonnextHoverTextColor")
                    }
                    className="h-10 w-1/2 cursor-pointer border border-gray-300 rounded-lg"
                  />
                  <input
                    type="text"
                    value={hexInputs.buttonnextHoverTextColor}
                    onChange={(e) =>
                      handleTextChange(e, "buttonnextHoverTextColor")
                    }
                    onBlur={() => handleTextBlur("buttonnextHoverTextColor")}
                    className="h-10 w-1/2 border border-gray-300 rounded-lg px-2 py-1 text-center"
                    placeholder="Enter hex or color name"
                  />
                </div>
              </div>
            </div>
            <button type="submit" className="joblist-btnclear">
              Update
            </button>
          </form>
        </aside>
      </div>
      <CustomToastContainer ref={toastRef} />
      {/* Pagination */}
    </div>
  );
};

export default IframeCode;
